import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "nav-menu" }
const _hoisted_2 = {
  key: 0,
  class: "home-title-container image-and-text-title-container"
}
const _hoisted_3 = {
  key: 0,
  class: "title-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, {
      class: "menu-header",
      mode: "md"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, {
          class: "main-menu",
          color: "background-transparent",
          mode: "md"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.pageTitle.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_ctx.imgSrc)
                      ? (_openBlock(), _createBlock(_component_ion_icon, {
                          key: 0,
                          src: _ctx.imgSrc,
                          class: "title-image"
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.pageTitle), 1)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isHomeScreen)
                ? (_openBlock(), _createBlock(_component_ion_icon, {
                    key: 1,
                    onClick: _ctx.returnHome,
                    icon: _ctx.homeSharp,
                    class: "left-home-image"
                  }, null, 8, ["onClick", "icon"]))
                : _createCommentVNode("", true),
              (!_ctx.isHomeScreen)
                ? _withDirectives((_openBlock(), _createBlock(_component_ion_icon, {
                    key: 2,
                    id: "mainMenuBackBtn",
                    onClick: _ctx.routeBack,
                    icon: _ctx.chevronBack,
                    class: "home-image back-button"
                  }, null, 8, ["onClick", "icon"])), [
                    [_vShow, !_ctx.pageLoading]
                  ])
                : _createCommentVNode("", true),
              _createVNode(_component_ion_title, { class: "nav-title" }, {
                default: _withCtx(() => [
                  (!_ctx.shouldShowIcon)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_ctx.imgSrc)
                          ? (_openBlock(), _createBlock(_component_ion_icon, {
                              key: 0,
                              src: _ctx.imgSrc,
                              class: "title-image"
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createElementVNode("div", null, [
                _createVNode(_component_ion_icon, {
                  onClick: _ctx.goToCalculator,
                  icon: _ctx.lockClosed,
                  mode: "md",
                  class: _normalizeClass(["home-image", _ctx.calculatorVisibilityClass])
                }, null, 8, ["onClick", "icon", "class"])
              ]),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, {
                    "auto-hide": "false",
                    onClick: _ctx.openMainMenu
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { style: {"display":"none"} }, {
      default: _withCtx(() => [
        _createElementVNode("input", {
          ref: "encryptedFileInput",
          class: "hidden-input",
          type: "file",
          id: "encryptedFile",
          accept: "text/plain,.bin",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setShouldExitApp && _ctx.setShouldExitApp(...args))),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.importJourneySets($event, true))),
          multiple: ""
        }, null, 544)
      ]),
      _: 1
    })
  ], 64))
}